export default __webpack_public_path__ + "static/media/m-pkhali-b.0a247c59.png";